export enum InsightCalculatorGroup {
  Glucose = "glucoseCalculations",
  Quartile = "quartileCalculations",
  Exercise = "exerciseCalculations",
  Food = "foodCalculations",
  Insulin = "insulinCalculations",
  TimeInRange = "timeInRangeCalculation",
  None = "noCalculations",
}
